import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchVideos } from '../../Service/VideoIndex_API/videoIndexApi';

export const getVideos = createAsyncThunk(
  'adminVideoIndex/getVideos',
  async ({ module_id, search, sortOrder, page, limit, userRole }, { rejectWithValue }) => {
    try {
      const data = await fetchVideos(module_id, search, sortOrder, page, limit, userRole);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch videos.');
    }
  }
);

const videoIndexSlice = createSlice({
  name: 'adminVideoIndex',
  initialState: {
    videos: [],
    course: null,
    module: null,
    pagination: {
      page: 1,
      limit: 10,
      totalItems: 0,
      totalPages: 1
    },
    loading: false,
    error: null
  },
  reducers: {
    setCurrentCourse: (state, action) => {
      state.course = action.payload;
    },
    setCurrentModule: (state, action) => {
      state.module = action.payload;
    },
    clearVideoIndexState: (state) => {
      state.videos = [];
      state.course = null;
      state.module = null;
      state.pagination = {
        page: 1,
        limit: 10,
        totalItems: 0,
        totalPages: 1
      };
      state.loading = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVideos.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getVideos.fulfilled, (state, action) => {
        state.loading = false;
        state.videos = action.payload.videos;
        state.pagination = action.payload.pagination;
      })
      .addCase(getVideos.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

// Actions
export const { setCurrentCourse, setCurrentModule, clearVideoIndexState } = videoIndexSlice.actions;

// Selectors
export const selectVideos = (state) => state.videoIndex?.videos || [];
export const selectCourse = (state) => state.videoIndex?.course;
export const selectModule = (state) => state.videoIndex?.module;
export const selectVideosPagination = (state) => state.videoIndex?.pagination || { page: 1, limit: 10, totalItems: 0, totalPages: 1 };

export default videoIndexSlice.reducer;
